import AddUpdateInventoryForm from 'components/Form/Tenant/Items/AddUpdateInventoryForm';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

const InventoryEntry: React.FC = () => {
  const { itemId, shopId } = useParams<{ itemId?: string; shopId?: string }>();
  return (
    <div className="page-content">
      <Container fluid>
        <AddUpdateInventoryForm itemId={itemId} shopId={shopId} />
      </Container>
    </div>
  );
};

export default InventoryEntry;
